export const LIST = [
  {
    title: 'Размещение объявлений',
    percent: '53',
    segments: ['Вторичная недвижимость', 'Коммерческая недвижимость', 'Посуточная недвижимость'],
    keyClients: ['Риелторы', 'Агентства', 'Собственники жилья'],
    url: '/ir-edu/core_business?scrollTo=adPlacement',
  },
  {
    title: 'Лидогенерация',
    percent: '31',
    segments: ['Новостройки', 'Посуточная аренда (партнёрские проекты)'],
    keyClients: ['Застройщики'],
    url: '/ir-edu/core_business?scrollTo=leadGeneration',
  },
  {
    title: 'Медийная выручка',
    percent: '9',
    segments: ['Новостройки', 'Коммерческая недвижимость'],
    keyClients: ['Застройщики', 'Банки'],
    url: '/ir-edu/core_business?scrollTo=mediaAd',
  },
  {
    title: 'Ипотека и электронная регистрация',
    percent: '5',
    segments: ['Новостройки', 'Вторичная недвижимость'],
    keyClients: ['Риелторы', 'Банки', 'Покупатели', 'Собственники'],
    url: '/ir-edu/transactional_business?scrollTo=elReg',
  },
];
